import { Businesses } from '@just-in-types';
import { firestore } from '../firebase';

export default async (
  businessId: string,
  siteId: string,
  targetBusinessId?: string,
) => {
  try {
    const sitesRef = firestore.collection(`businesses/${businessId}/sites`);
    const doc = await sitesRef.doc(siteId).get();
    const siteData = doc.data() as Businesses.Site;

    if (targetBusinessId) {
      return firestore
        .collection(`businesses/${businessId}/sites`)
        .add(siteData);
    }

    return sitesRef.add(siteData);
  } catch (error) {
    throw new Error(error);
  }
};



// WEBPACK FOOTER //
// ./src/adminFunctions/duplicateSite.ts